export var dataHooks = {
    sliderTooltip: 'slider-tooltip',
    sliderHandle: 'slider-handle',
    sliderMarkLabel: 'slider-mark-label',
    sliderThumb: 'slider-thumb',
};
//# sourceMappingURL=constants.js.map